"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const material_1 = require("@mui/material");
const makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const useStyles = (0, makeStyles_1.default)(() => ({
    action: {
        textDecoration: "none",
    },
    media: {
        height: "140px",
    },
    title: {
        "&:first-letter": {
            textTransform: "capitalize",
        },
    },
    card: {
        height: "100%",
    },
}));
function Actions({ title, subtitle, image, href }) {
    const classes = useStyles();
    return (react_1.default.createElement(react_router_dom_1.Link, { to: href, className: classes.action },
        react_1.default.createElement(material_1.Card, { className: classes.card },
            react_1.default.createElement(material_1.CardActionArea, null,
                image && (react_1.default.createElement(material_1.CardMedia, { className: classes.media, title: title, image: image })),
                react_1.default.createElement(material_1.CardContent, null,
                    react_1.default.createElement(material_1.Typography, { className: classes.title, gutterBottom: true, variant: "h2" }, title),
                    react_1.default.createElement(material_1.Typography, { variant: "body1", color: "textSecondary", component: "p" }, subtitle))))));
}
exports.default = Actions;
